export const NAVBAR_HEIGHT = 100;

export const SIDEBAR_WIDTH = 260;

export const FOOTER_HEIGHT = 243;
